import { Tooltip } from '@loomhq/lens';
import React from 'react';

const TOOLTIP_MAX_WIDTH = 500;

const ConditionalTooltip = ({ content, showTooltip, children }) =>
  showTooltip ? (
    <Tooltip
      content={content}
      placement="bottomCenter"
      maxWidth={TOOLTIP_MAX_WIDTH}
    >
      {children}
    </Tooltip>
  ) : (
    children
  );

export default ConditionalTooltip;
